const ConfirmationAlert = ({sendJoiningFormHandler,alertPopup}) =>{
    return (
        <>
        <div id="confirm_alert" className="alert_modal modal fade" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-sm">
          <div className="modal-content">
            <div className="modal-body text-center">
                <div className="alert_icon_blk">
                    <i className="icon icon-paper-plane"></i>
                </div>
              <h4>Are you sure?</h4>
              <p>Do you want to Send Joining Form?</p>
              <button type="button" className="btn_9 mr05" onClick={()=>sendJoiningFormHandler(alertPopup)} data-bs-dismiss="modal">Yes</button>
              <button type="button" className="btn_6" data-bs-dismiss="modal">No</button>
            </div>
          </div>
        </div>
      </div>
        </>
    )
}
export default ConfirmationAlert